import { createFileRoute, redirect } from '@tanstack/react-router'
import { isHalloweenEligibleNow } from '@/modules/halloween/eligibility'

interface ClientParams {
  readonly orgSlug: string
  readonly clientSlug: string
}

/** The Graveyard is a hidden page: anyone who is not eligible lands on the client overview. */
export function guardGraveyard(params: ClientParams): void {
  if (!isHalloweenEligibleNow()) {
    throw redirect({ to: '/$orgSlug/$clientSlug', params })
  }
}

export const Route = createFileRoute('/$orgSlug/$clientSlug/graveyard')({
  beforeLoad: ({ params }) => guardGraveyard(params),
})
